// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import UserAvatarGroup from '../../../../../../components/userAvatar/UserAvatarGroup';

// Constants
import { USER_AVATAR_SIZES } from '../../../../../../../common/users/userConstants';

// Styles
import './NotificationFigureUser.scss';

const getTooltipOffset = () => 8;

const NotificationFigureUser = ({ actors, icon, size = USER_AVATAR_SIZES.SMALL }) => (
    <div className="NotificationFigureUser">
        <UserAvatarGroup users={actors} size={size} getTooltipOffset={getTooltipOffset} />
        <div className="overlay-icon">{icon}</div>
    </div>
);

NotificationFigureUser.propTypes = {
    actors: PropTypes.array,
    icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    size: PropTypes.number,
};

export default NotificationFigureUser;
